import { put, select, takeLatest } from 'redux-saga/effects'
import { IMultiSelectProps } from '../../../components/multiSelect/MultiSelect.component'
import { getProcedureStateSelector } from '../../../components/procedure/selectors/getProcedureState.selector'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors/intubation.selector'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setReasonsForFailure() {
  const { inputRows }: IProcedureState = yield select(getProcedureStateSelector)
  const { reasonsForFailure }: IIntubationState = yield select(getIntubationSelector)
  try {
    inputRows.forEach((row) =>
      row.inputs.forEach((input) => {
        if (input.key === IntubationConstants.SET_REASONS_FOR_FAILURE) {
          const props = input.props as IMultiSelectProps
          props.savedValues = reasonsForFailure
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setReasonsForFailure() error: ${e}`))
  }
}

export function* setReasonsForFailureSaga() {
  yield takeLatest([IntubationConstants.SET_REASONS_FOR_FAILURE], setReasonsForFailure)
}
